module.exports = __webpack_public_path__ + "img/31.6ed8e3ad.jpg";